export const APP_KEY = 'risman-loveable-clone';

const baseState = {
  auth: {
    isAuthenticated: false,
    user: null,
    authMode: 'login',
    otpSent: false,
    otpCode: null,
    loading: false,
    error: null,
    mobile: '',
    accessToken: null,
    otpExpiresInSeconds: 120,
    otpRequestedAt: null
  },
  app: {
    language: 'fa',
    theme: 'light'
  },
  projects: {
    activeTab: 'your',
    selectedProjectId: null
  },
  chat: {
    byChatId: {},
    latestResultByChatId: {}
  },
  chats: {
    byProjectId: {},
    activeChatIdByProjectId: {}
  },
  preview: {
    viewMode: 'desktop',
    byProjectId: {}
  }
};

export const loadAppState = () => {
  try {
    const raw = localStorage.getItem(APP_KEY);
    if (!raw) {
      return baseState;
    }
    const parsed = JSON.parse(raw);
    return {
    ...baseState,
    ...parsed,
    app: { ...baseState.app, ...(parsed.app || {}) },
    auth: { ...baseState.auth, ...(parsed.auth || {}), loading: false },
    projects: {
      ...baseState.projects,
      activeTab: (parsed.projects || {}).activeTab || baseState.projects.activeTab,
      selectedProjectId: (parsed.projects || {}).selectedProjectId || baseState.projects.selectedProjectId
    },
      chat: baseState.chat,
      preview: {
        ...baseState.preview,
        viewMode: (parsed.preview || {}).viewMode || baseState.preview.viewMode,
        byProjectId: baseState.preview.byProjectId
      }
    };
  } catch (error) {
    return baseState;
  }
};

export const saveAppState = (state) => {
  const { loading: _loading, ...authToPersist } = state.auth;
  const persisted = {
    auth: authToPersist,
    app: state.app,
    projects: {
      activeTab: state.projects.activeTab,
      selectedProjectId: state.projects.selectedProjectId
    },
    preview: {
      viewMode: state.preview.viewMode
    }
  };
  localStorage.setItem(APP_KEY, JSON.stringify(persisted));
};

export const getBaseState = () => baseState;

export const getAuthToken = () => {
  try {
    const raw = localStorage.getItem(APP_KEY);
    if (!raw) {
      return null;
    }

    const parsed = JSON.parse(raw);
    return parsed?.auth?.accessToken || null;
  } catch (error) {
    return null;
  }
};

export const clearPersistedAuth = () => {
  try {
    const raw = localStorage.getItem(APP_KEY);

    if (!raw) {
      return;
    }

    const parsed = JSON.parse(raw);
    const nextState = {
      ...parsed,
      auth: {
        ...baseState.auth
      }
    };

    localStorage.setItem(APP_KEY, JSON.stringify(nextState));
  } catch (error) {
    localStorage.removeItem(APP_KEY);
  }
};

const PENDING_PROMPT_KEY = `${APP_KEY}:pending-prompt`;

export const savePendingPrompt = (prompt) => {
  try {
    localStorage.setItem(PENDING_PROMPT_KEY, prompt);
  } catch (error) {
    // Ignore storage failures so the CTA flow still works.
  }
};

export const getPendingPrompt = () => {
  try {
    return localStorage.getItem(PENDING_PROMPT_KEY) || '';
  } catch (error) {
    return '';
  }
};

export const clearPendingPrompt = () => {
  try {
    localStorage.removeItem(PENDING_PROMPT_KEY);
  } catch (error) {
    // Ignore storage failures.
  }
};

const PENDING_TEMPLATE_CLONE_KEY = `${APP_KEY}:pending-template-clone`;

export const savePendingTemplateClone = (projectId) => {
  try {
    if (projectId) {
      localStorage.setItem(PENDING_TEMPLATE_CLONE_KEY, projectId);
    }
  } catch (error) {
    // Ignore storage failures.
  }
};

export const getPendingTemplateClone = () => {
  try {
    return localStorage.getItem(PENDING_TEMPLATE_CLONE_KEY) || '';
  } catch (error) {
    return '';
  }
};

export const clearPendingTemplateClone = () => {
  try {
    localStorage.removeItem(PENDING_TEMPLATE_CLONE_KEY);
  } catch (error) {
    // Ignore storage failures.
  }
};
